import * as angular from "angular";
import {AddressesService} from "./services/addresses-service.factory";

angular
  .module('bringoz.admin.addresses')
  .config(AddressesStateConfig);

/* @ngInject */
function AddressesStateConfig($stateProvider) {
  $stateProvider

    // Addresses Resolver View
    .state('addresses-resolver', {
      parent: 'bringoz.site',
      url: '/address-validations?:priority',
      template: '<addresses-resolver-view quality="quality"></addresses-resolver-view>',
      controller: function ($scope, triBreadcrumbsService, $stateParams, site) {

        $scope.quality = $stateParams.quality || 'Low';

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Address Validations"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })
    .state('addresses-resolver-details', {
      parent: 'bringoz.site',
      url: '/address-validations/:id',
      template: '<addresses-resolver-view address="vm.address" quality="vm.quality"></addresses-resolver-view>',
      controllerAs: 'vm',
      controller: function ($filter, triBreadcrumbsService, address, site) {
        this.address = address;
        this.quality = address.qualityGroup;

        const formatedAddress = $filter('bringozAddress')(address.originalAddress);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: formatedAddress, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Address Validations", state: 'addresses-resolver'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        addressesId: (site, $stateParams) => {
          return $stateParams.id;
        },
        address: (addressesId, addressesService: AddressesService) => {
          return addressesService.getAddressByAddressId(addressesId);
        }
      }
    })
}
